module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 138.c227d027.png";